import {useTranslation} from '@aboutyou/i18n';
import {useHistory, useSearchRoute} from '@aboutyou/router';
import {
  Button,
  FONT_WEIGHTS,
  GenericIconName,
  Icon,
  SIZE,
  SPACING,
  Text,
  tabletAndUpLinaria,
} from '@aboutyou/ui-components';
import {styled} from '@linaria/react';
import React from 'react';
import {usePotentialFilters} from '../../../features/ProductStream/utils';
import {SearchSuggestions} from '../../Header/SearchBar/SearchSuggestions';
import {useSearchBarDisplayState} from '../../Header/SearchBar/hooks/useSearchBarDisplayState';
import {useSearchPageFiltersSection} from '../hooks/useSearchPageBulkSection';

export const SearchStreamEmpty = () => {
  const {t} = useTranslation();
  const searchRoute = useSearchRoute();
  const history = useHistory();

  const filtersSection = useSearchPageFiltersSection();

  const hasAppliedFilters = !!filtersSection?.data?.appliedFiltersCount;
  const {resetAllFilters} = usePotentialFilters();

  const {searchInputRef, searchWrapperRef} = useSearchBarDisplayState();

  return (
    <Container data-testid="SearchStreamEmpty">
      <IconWrapper asset={GenericIconName.Search} />

      <TextsWrapper>
        <Headline as="h1" size="px20">
          {t('Oops.. No results found')}
        </Headline>

        <Subline as="h3" size="px16">
          {t('Try adjusting your search to find what you’re looking for')}
        </Subline>
      </TextsWrapper>

      {hasAppliedFilters ? (
        <StyledButton
          variant="secondary"
          size="full-width"
          onClick={e => {
            e.preventDefault();
            resetAllFilters();
          }}
        >
          {t('Clear all filters')}
        </StyledButton>
      ) : (
        <StyledButton
          variant="secondary"
          size="full-width"
          onClick={e => {
            e.preventDefault();
            history.push(searchRoute);
          }}
        >
          {t('Search again')}
        </StyledButton>
      )}
      <SearchWrapper>
        <StyledSearchSuggestions
          searchInputRef={searchInputRef}
          searchWrapperRef={searchWrapperRef}
          isSearchInTabletMode={false}
          isSearchBarExpanded={false}
          expandSearchBar={() => undefined}
          collapseSearchBar={() => undefined}
        />
      </SearchWrapper>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  padding: ${SPACING['X.Xl6']} ${SPACING['X.Xl2']};
  gap: 8px;
  margin-top: -${SIZE.U5};
`;

const IconWrapper = styled(Icon)`
  width: 22px;
  height: 22px;
`;

const Headline = styled(Text)`
  margin: 0;
  font-weight: ${FONT_WEIGHTS.mediumHeavy};
  text-align: center;
`;

const Subline = styled(Text)`
  margin: 0;
  font-weight: ${FONT_WEIGHTS.mediumBold};
  text-align: center;
`;

const TextsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: ${SPACING['X.Md']} ${SPACING['X.None']};
`;

const StyledButton = styled(Button)`
  ${tabletAndUpLinaria(`
    display: none;
  `)}
`;

const SearchWrapper = styled.div`
  display: none;

  ${tabletAndUpLinaria(`
    display: flex;
    position: relative;
    height: 36px;
    width: 320px;
    align-self: center;
    justify-self: center;
    padding-top: ${SPACING['X.Lg']};
  `)}
`;

const StyledSearchSuggestions = styled(SearchSuggestions)`
  max-width: 100%;
`;
